import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SidebarLeftService {
  collapsed = true;

  toggleCollapsed() {
    this.collapsed = !this.collapsed;
  }
}
